import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledLinkChip = styled(Chip)(({ theme }) => ({
  width: 'fit-content',
  '& .MuiChip-label': {
    color: theme.palette.primary.main,
  },
}));
